import { render, staticRenderFns } from "./WeightsComparerDialog.vue?vue&type=template&id=1b3e8eae"
import script from "./WeightsComparerDialog.vue?vue&type=script&lang=ts"
export * from "./WeightsComparerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports